import { BubbleMenu as BaseBubbleMenu, Editor } from "@tiptap/react";
import { useCallback, useRef } from "react";
import { Instance, sticky } from "tippy.js";
import { v4 as uuidv4 } from "uuid";
// import deepEql from "fast-deep-equal";

import { Icon, Toolbar, Tooltip } from "utils/ui";

import { MenuProps } from "../types";
import { getRenderContainer } from "../../../utils";

export const SpacerBlockMenu = ({ editor, appendTo }: MenuProps): JSX.Element => {
  const menuRef = useRef<HTMLDivElement>(null);
  const tippyInstance = useRef<Instance | null>(null);

  const getReferenceClientRect = useCallback(() => {
    const renderContainer = getRenderContainer(editor, "node-spacerBlock");
    const rect = renderContainer?.getBoundingClientRect() || new DOMRect(-1000, -1000, 0, 0);

    return rect;
  }, [editor]);

  const shouldShow = useCallback(() => {
    const isActive = editor.isActive("spacerBlock");

    return isActive;
  }, [editor]);

  return (
    <BaseBubbleMenu
      editor={editor}
      pluginKey={`spacerBlockMenu-${uuidv4()}`}
      shouldShow={shouldShow}
      updateDelay={0}
      tippyOptions={{
        offset: [0, 8],
        zIndex: 1000,
        popperOptions: {
          modifiers: [{ name: "flip", enabled: false }],
        },
        getReferenceClientRect,
        onCreate: (instance: Instance) => {
          tippyInstance.current = instance;
        },
        appendTo: () => {
          return appendTo?.current;
        },
        plugins: [sticky],
        sticky: "popper",
      }}
    >
      <div ref={menuRef}>
        <SpacerMenu editor={editor} />
      </div>
    </BaseBubbleMenu>
  );
};

export const SpacerMenu = ({ editor }: { editor: Editor }) => {
  // const { height } = useEditorState({
  //   editor,
  //   selector: (ctx) => {
  //     return {
  //       height: parseInt(ctx.editor.getAttributes("spacerBlock")?.height || 0),
  //     };
  //   },
  //   equalityFn: deepEql,
  // });

  // const onWidthChange = useCallback(
  //   (value: number) => {
  //     editor.chain().focus(undefined, { scrollIntoView: false }).setSpacerBlockHeight(value).run();
  //   },
  //   [editor]
  // );

  const onDelete = useCallback(() => {
    editor.chain().focus(undefined, { scrollIntoView: false }).deleteSelection().run();
  }, [editor]);

  return (
    <Toolbar.Wrapper
      title="Vertical Spacer"
      // shouldShowContent={shouldShow()}
    >
      {/* <Tooltip title="Change height">
        <SpacerBlockHeight onChange={onWidthChange} value={height} />
      </Tooltip> */}

      <Toolbar.Divider />

      <Tooltip title="Remove spacer">
        <Toolbar.Button onClick={onDelete}>
          <Icon name="Trash2" />
        </Toolbar.Button>
      </Tooltip>
    </Toolbar.Wrapper>
  );
};
